import UiLstStoreBase from '../../cls/stores/UiLstStoreBase'

/**
 * @class UiLstRecruitmentStore
 * @extends UiLstStoreBase
 * @description This class represents the store for the UI list of recruitment. It extends the UiLstStoreBase class and initializes the recruitment store with default filters.
 */
class UiLstRecruitmentStore extends UiLstStoreBase {
	/**
	 * @constructor
	 * @param {object} rootStore - The root store that holds the global state and other stores.
	 * @description Constructs an instance of UiLstRecruitmentStore with the specified root store and initializes the store with default filters.
	 */
	constructor(rootStore) {
		// Call the parent constructor with the root store and default filters
		super(rootStore, {
			progress: 'pending, reviewed, approved',
			show_all: false
		})
	}
}

export default UiLstRecruitmentStore
